/* eslint-disable @typescript-eslint/no-explicit-any */
import hoistNonReactStatics from 'hoist-non-react-statics';
import React from 'react';
export function makeHoc(_ref) {
  let {
    useGetData,
    getDisplayName,
    getPropTypes
  } = _ref;
  return Component => {
    var _ref2, _Component$displayNam;
    const WrapperComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
      const data = useGetData(props);
      return /*#__PURE__*/React.createElement(Component, Object.assign({
        ref: ref
      }, data, props));
    });
    const componentName = (_ref2 = (_Component$displayNam = Component.displayName) !== null && _Component$displayNam !== void 0 ? _Component$displayNam : Component.name) !== null && _ref2 !== void 0 ? _ref2 : 'Component';
    WrapperComponent.displayName = getDisplayName(componentName);
    WrapperComponent.defaultProps = Component.defaultProps;
    if (Component.propTypes) {
      WrapperComponent.propTypes = getPropTypes(Component.propTypes);
    }
    return hoistNonReactStatics(WrapperComponent, Component);
  };
}
//# sourceMappingURL=make-hoc.js.map